import React, {FC} from "react";
import {useIntl} from "react-intl";
import Detail from "./Detail";
import { PageTitle } from "../../../../../_metronic/layout/core";

const ViewImportRequestWrapper: FC = () => {
  const intl = useIntl();
  const breadcrumbs = [
    {
      title: intl.formatMessage({id: 'MENU.DASHBOARD'}),
      path: '/dashboard',
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({id: 'MENU.WAREHOUSE'}),
      path: '/warehouse/list',
      isActive: true,
    },
    {
      title: 'Nhập hàng ký gửi',
      path: '/warehouse/receipt/import-requests',
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    }
  ]
  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Yêu cầu nhập hàng ký gửi </PageTitle>
      <Detail/>
    </>
  )
}
export default ViewImportRequestWrapper;